export default __webpack_public_path__ + "static/media/create-cra-app.73b0c0bb.md";